(function(app) {
    app.constant("externalLoading2",
        {
            html:
            "<html>" +
                "<head>" +
                "<title></title>" +
                "</head>" +
                "<body>" +
                "   <header>" +
                "   <style>" +
                "     html, body { margin: 0; padding: 0; background: #ebf1f5; color: #754545 }" +
                "      .centeredDiv { position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; width: 400px; height: 400px; text-align: center }" +
                "      .loader-wrap { height: 100%; width: 100%; display: flex; }" +
                "      .loader-main { border: 12px solid #c8d8e3;border-radius: 50%; border-top: 12px solid #754545; width: 72px; height: 72px; max-width: 40%; - moz - animation: spin 1.5s linear infinite; -o - animation: spin 1.5s linear infinite; -webkit - animation: spin 1.5s linear infinite; animation: spin 1.5s linear infinite; margin: auto; }" +
                "      @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } } " +
                "   </style> " +
                "   </header> " +
                "   <div class='centeredDiv'> " +
                "       <div class='loader-wrap'> " +
                "           <div class='loader-main'>" +
                "       </div> " +
                "   </div >" +
                "</body > " +
            "</html> "
        });
})(window.app); //jshint ignore:line